import React, { useEffect } from 'react';
import { Col } from 'react-bootstrap';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserView, MobileView } from 'react-device-detect';
import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import Lottie from 'lottie-react';
import frameAnimation from '../../Assets/Frame 38.json';
import './landing.css';

gsap.registerPlugin(ScrollTrigger);

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function Landing() {
  useEffect(() => {
    // GSAP animation to change width and scale when scrolling down
    gsap.to('.image-containerlanding img', {
      scale: 1.2, // Zoom in effect on scroll
      width: '100%', // Expand the width from 40% to 100%
      ease: 'power2.out', // Smoother transition with ease
      scrollTrigger: {
        trigger: '.image-containerlanding', // The element that triggers the animation
        start: 'top top', // When the top of the image hits the top of the viewport
        end: 'bottom top', // When the bottom of the image reaches the top of the viewport
        scrub: 1, // Animation follows the scroll position
        markers: false, // Set to true to visualize the trigger points (useful for debugging)
      },
    });
  }, []);

  return (
    <div style={{ overflowX: 'hidden', position: 'relative' }}>
      <div className="floating-buttons">
        <div className='whatsapp-button' onClick={() => handleWhatsAppClick("I am interested in Piercing")}>
          <img src={whatsapp} alt="WhatsApp" className="icon" />
        </div>
        <a href="tel:+971567257579" className="call-button">
          <img src={call} alt="Call" className="icon" />
        </a>

      </div>
      <BrowserView>
        {/* GIF in top-right corner */}
        <div className="animation-container">
          <div
            style={{ 
              position: 'absolute', 
              top: '250px', // Keep the same top position
              right: '200px', // Keep the same right position
              width: '150px', // Set the desired width
              height: 'auto', 
              zIndex: 10 // Ensures the animation overlays other elements
            }}
          >
            <Lottie 
              animationData={frameAnimation} 
              loop={true} // Make the animation loop
              style={{ width: '100%', height: 'auto' }} // Make the animation responsive
            />
          </div>
        </div>

        {/* Browser View for desktop */}
        <div className="image-containerlanding landing-container" style={{ position: 'relative', overflow: 'hidden', height: '70vh' }}>
          {/* Image starts at 40% width */}
          <img
            src={require('../../Assets/landing01.png')}
            alt="Adorn Image"
            style={{ width: '40%', objectFit: 'cover', maxWidth: '100%', height: '70vh', borderBottomRightRadius: '50%' }} // Ensuring the image fills the container
          />
        </div>

        {/* Two-column layout */}
        <div className="two-column-layout" style={{ padding: '20px', margin: '0' }}>
          <Col xs={11} md={8} lg={8}>
            <div className='hero-text' style={{ marginBottom: '10px' }}>
              <h1>Your body, your canvas.</h1>
              <h2>Adorn it beautifully.</h2>
            </div>
            <div style={{ marginBottom: '15px' }}>
              <a href="/allservices">
                <button className="landing-btn">View Our Services</button>
              </a>
            </div>
            <br />

            <div className='hero-text' style={{ marginBottom: '10px' }}>
              <h3>Who we are?</h3>
              <h2>Piercing service UAE</h2>
            </div>
            <p className='para' style={{ marginBottom: '10px' }}>
              We're a passionate team dedicated to offering our clients a truly unique experience. 
              Our jewelry shop celebrates freedom in art and self-expression, embracing inclusivity, 
              creativity, and innovation. Visit us in Dubai or Abu Dhabi and discover a treasure you'll cherish forever.
            </p>
            <p className='para' style={{ marginBottom: '0px' }}>
              Founded in Dubai in 2010, we've quickly become one of the most sought-after destinations for jewelry and piercing
              across the UAE in under a year. With a growing community of over 50,000 followers on social media, our certified
              staff brings more than seven years of expertise, ensuring every experience is exceptional. We're proud of the
              reputation we've built and the trust we've earned.
            </p>
          </Col>

          <Col xs={11} md={8} lg={4}>
            <div className="image-container2" style={{ marginBottom: '10px' }}>
              <img 
                src={require('../../Assets/landing2.png')} 
                alt="Adorn Image" 
                style={{ 
                  maxWidth: '100%', 
                  objectFit: 'cover', 
                  float: 'right' /* Aligns the image to the right */
                }} 
              />
            </div>
          </Col>

        </div>
      </BrowserView>
      
      <MobileView>

        {/* Browser View for desktop */}
        <div className="image-containerlanding landing-container" style={{ position: 'relative', overflow: 'hidden', height: '70vh' }}>
          {/* Image starts at 40% width */}
          <img
            src={require('../../Assets/landing01.png')}
            alt="Adorn Image"
            style={{ width: '100%', objectFit: 'cover', maxWidth: '100%', height: '70vh' }} // Ensuring the image fills the container
          />

          {/* Text added here above the button */}
          <div className="text-and-button-container">
            <p className="first-line">PIERCING SERVICE UAE</p>
            <p className="second-line">JEWELLERY & PIERCING</p>
            <div style={{ marginBottom: '15px' }}>
              <a href="/allservices">
                <button className="landing-btn">View Our Services</button>
              </a>
            </div>
          </div>

        </div>


        {/* Two-column layout for mobile */}
        <div className="two-column-layout">
          <Col xs={11} md={8} lg={8}>
            <div className='hero-text'>
              <h1>Your body, your canvas.</h1>
              <h2>Adorn it beautifully.</h2>
            </div>
            <br/>

            <div className='hero-text'>
              <h3>Who we are?</h3>
              <h2>Piercing service UAE</h2>
            </div>
            <p className='para'>
              We're a passionate team dedicated to offering our clients a truly unique experience. 
              Our jewelry shop celebrates freedom in art and self-expression, embracing inclusivity, 
              creativity, and innovation. Visit us in Dubai or Abu Dhabi and discover a treasure you'll cherish forever.
            </p>
            <p className='para'>
              Founded in Dubai in 2010, we've quickly become one of the most sought-after destinations for jewelry and piercing across the UAE in under a year.
              With a growing community of over 50,000 followers on social media, our certified staff brings more than seven years of expertise, ensuring every experience is exceptional.
              We're proud of the reputation we've built and the trust we've earned.
            </p>
          </Col>
        </div>
      </MobileView>
    </div>
  );
}

export default Landing;
